import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

type AppLocale = 'fr' | 'en';
const DEFAULT_TIME_ZONE = 'America/Toronto';

void i18n.use(initReactI18next).init({
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: { escapeValue: false },
  resources: {
    fr: {
      translation: {
        dashboard: 'Vue d’ensemble',
        myActions: 'Mes actions',
        dataQuality: 'Error Log',
        projects: 'Projets',
        capacity: 'Capacité',
        resources: 'Ressources',
        insights: 'Insights',
        planning: 'Planning',
        planningTriage: 'Triage du planning',
        budgets: 'Budgets',
        billing: 'Facturation',
        financialForecast: 'Prévision financière',
        governance: 'Gouvernance',
        reports: 'Rapports',
        integrations: 'Connexions à Pulse',
        settings: 'Réglages',
        settingsNavClients: 'Clients et suivi',
        tempoTracking: 'Comptes Tempo',
        settingsForecast: 'Configuration de la capacité',
        settingsRates: 'Taux clients',
        settingsBudgetImports: 'Import des budgets',
        accessAdmin: {
          navigation: 'Administration',
          title: 'Accès et équipes Tempo',
          intro:
            'Consultez les équipes Tempo et gérez les droits locaux dans les périmètres d’accès.',
          users: 'Utilisateurs',
          roles: 'Rôles',
          teams: 'Équipes',
          review: 'Revue des accès',
          projects: 'Projets',
          resources: 'Ressources',
          members: 'Membres',
          newUser: 'Nouvel utilisateur',
          newRole: 'Nouveau rôle',
          newTeam: 'Nouvelle équipe',
          email: 'Courriel Novatize',
          description: 'Description',
          globalRoles: 'Rôles globaux',
          teamRoles: 'Rôles dans les équipes',
          activeAccount: 'Compte actif',
          active: 'Actif',
          disabled: 'Désactivé',
          archived: 'Archivé',
          archive: 'Archiver',
          restore: 'Restaurer',
          pending: 'Accès en attente',
          projectScope: 'Portée équipe ou globale',
          globalScope: 'Portée globale uniquement',
          permissionLevels: {
            read: 'Voir',
            manage: 'Gérer',
            sensitive: 'Action sensible',
          },
          permissionGroups: {
            users: 'Utilisateurs',
            roles: 'Rôles',
            teams: 'Équipes',
            api_docs: 'Documentation API',
            clients: 'Clients',
            projects: 'Projets',
            capacity: 'Capacité',
            forecast: 'Prévisions',
            financials: 'Taux client',
            agent: 'Agent',
            planning: 'Planning',
            budgets: 'Budgets',
            billing: 'Facturation',
            governance: 'Gouvernance',
            reports: 'Rapports',
            settings: 'Configuration',
            integrations: 'Intégrations',
          },
        },
        settingsClients: {
          title: 'Settings',
          intro: 'Choisissez les clients et projets Tempo qui alimentent les vues opérationnelles.',
          clients: 'Clients',
          refresh: 'Actualiser depuis Tempo',
          refreshing: 'Mise en file…',
          refreshQueued: 'Synchronisation Tempo mise en file.',
          excluded: '{{count}} Account(s) Tempo exclus faute de Customer.',
          excludedHelp: 'Ajoutez leur Customer dans Tempo pour les rendre admissibles.',
          search: 'Rechercher',
          searchPlaceholder: 'Client, projet ou clé Tempo',
          tracking: 'Suivi',
          all: 'Tous',
          tracked: 'Suivis',
          untracked: 'Non suivis',
          tempoStatus: 'Statut Tempo',
          clientProject: 'Client / projet',
          key: 'Clé',
          status: 'Statut',
          activity: 'Activité',
          spaces: 'Spaces',
          projectsTracked: '{{tracked}}/{{total}} projets suivis',
          automatic: 'Automatique',
          manual: 'Manuel',
          followed: 'Suivi',
          ignored: 'Ignoré',
          returnAutomatic: 'Revenir en auto',
          noCategory: 'Sans catégorie',
          defaultSpace: 'défaut',
          ambiguousMapping: 'mapping ambigu',
          notLinked: 'Non lié',
          inheritClient: 'Hériter du client',
          contractSigned: 'Projet signé',
          signed: 'Signé',
          notSigned: 'À signer',
          configureBillingEpic: 'Configurer l’epic TCC',
          billingEpic: 'Epic TCC',
          billingEpicHelp:
            'Le titre contrôlé est utilisé par défaut; un choix Jira est facultatif.',
          billingEpicAutomatic: 'Automatique — titre contrôlé par défaut',
          saveBillingEpic: 'Enregistrer l’epic TCC',
          savingBillingEpic: 'Enregistrement…',
          loadingBillingEpic: 'Chargement des candidats Jira…',
          billingEpicError: 'Impossible de charger les candidats Jira.',
          noRecentActivity: 'Aucune activité récente',
          expand: 'Développer {{name}}',
          collapse: 'Réduire {{name}}',
        },
        shell: {
          mainNavigation: 'Navigation principale',
          settingsNavigation: 'Sections des réglages',
          integrationsNavigation: 'Sections des intégrations',
          searchLabel: 'Recherche globale',
          searchPlaceholder: 'Rechercher projet ou personne',
          searchLoading: 'Recherche…',
          searchEmpty: 'Aucun résultat autorisé.',
          accessPending: 'Accès en attente',
          accessPendingDescription:
            'Votre compte est actif, mais aucun rôle ne vous a encore été attribué.',
          loading: 'Chargement sécurisé…',
          apiUnavailable: 'L’application ne peut pas joindre son API.',
          unexpectedError: 'Une erreur inattendue est survenue.',
          helpCenter: 'Centre d’aide',
          french: 'Français',
          english: 'English',
          englishExperimentalTitle:
            'English est encore expérimental; certaines vues restent en français.',
          frenchReferenceTitle: 'Revenir à la langue de référence complète.',
        },
        integrationPage: {
          title: 'Intégrations',
          intro:
            'Connecteurs externes en lecture seule, réconciliation nocturne et synchronisation auditée.',
          health: 'Santé et synchronisations',
          configuration: 'Configuration',
          reconciliation: 'Rapprochement',
          fullReconciliation: 'Réconciliation complète',
          configured: 'Configuré',
          disconnected: 'Déconnecté',
          notConfigured: 'Non configuré',
          test: 'Tester',
          sync: 'Synchroniser',
          disconnect: 'Déconnecter',
          reconnect: 'Reconnecter',
          confirmReconnect: 'Reconnecter HubSpot et réactiver ses synchronisations ?',
          confirmDisconnect:
            'Déconnecter HubSpot ? Les données et mappings existants seront conservés.',
          recentRuns: 'Exécutions récentes',
          lastRun: 'Dernière exécution',
          inProgress: 'mise à jour en cours',
          syncFailed: 'Échec de la synchronisation.',
          connectionConfirmed: 'Connexion confirmée',
        },
        dataQualityPage: {
          title: 'Qualité des données',
          intro:
            'Contrats, mappings, budgets et taux manquants, priorisés avec une action corrective.',
          allStatuses: 'Tous les statuts',
          open: 'Ouvert',
          resolved: 'Résolu',
          ignored: 'Ignoré',
          allPriorities: 'Toutes les priorités',
          critical: 'Critique',
          high: 'Haute',
          medium: 'Moyenne',
          low: 'Basse',
          refresh: 'Réanalyser',
          none: 'Aucune anomalie détectée.',
          owner: 'Responsable de {{kind}} — {{project}}',
          priority: 'Priorité de {{kind}} — {{project}}',
          noOwner: 'Aucun responsable',
          resolve: 'Résoudre',
          ignore: 'Ignorer',
          sourceDetected: 'Source {{source}} · détecté le {{date}}',
          anomalies: 'anomalie',
          anomaliesPlural: 'anomalies',
        },
        forecastSettingsPage: {
          title: 'Configuration de la capacité',
          intro:
            'Définissez les valeurs organisationnelles et vérifiez les rôles principaux et engagements synchronisés depuis Tempo.',
          save: 'Enregistrer les valeurs par défaut',
          saving: 'Enregistrement…',
          capacity: 'Capacité et cible facturable',
          thresholds: 'Seuils d’alerte',
          weeklyCapacity: 'Capacité hebdomadaire (h)',
          weeklyTarget: 'Cible facturable (h)',
          rounding: 'Arrondi des réservations (min)',
          sprintAnchor: 'Ancre du sprint (mercredi)',
          sprintLength: 'Cadence du sprint (semaines)',
          inactivity: 'Aucune activité récente après (jours)',
          tempoTeam: 'Équipe Tempo, capacité et rôles principaux',
        },
        login: {
          eyebrow: 'Gestion de production',
          title: 'Une vue fiable sur la charge et la rentabilité.',
          description: 'Accès réservé aux comptes Google @novatize.com.',
          continue: 'Continuer avec Google',
          oauthMissing: 'Google OAuth doit être configuré.',
        },
        dataChain: {
          save: 'Enregistrer',
          cancel: 'Annuler',
          close: 'Fermer',
          create: 'Créer',
          add: 'Ajouter',
          edit: 'Modifier',
          manage: 'Gérer',
          syncAll: 'Synchroniser tout',
          map: 'Mapper',
          mapConfirm: 'Mapper et confirmer',
          contractStart: 'Début de production',
          contractEnd: 'Fin de production',
          contract: 'Contrat',
          purchaseOrder: 'Bon de commande',
          currency: 'Devise',
          name: 'Nom',
          category: 'Catégorie',
          amount: 'Montant',
          budgetHours: 'Heures budgétées',
          resource: 'Ressource',
          expertise: 'Expertise',
          type: 'Type',
          start: 'Début',
          end: 'Fin',
          hours: 'Heures',
          title: 'Titre',
          dueDate: 'Échéance',
          description: 'Description',
          context: 'Contexte',
          reason: 'Motif',
          date: 'Date',
          unavailableHours: 'Heures indisponibles',
          destinationProject: 'Projet de destination',
          tempoAccount: 'Tempo Account',
          startDateField: 'Date de début',
          jiraAbsenceIds: 'Tickets Jira des absences Tempo Timesheets',
        },
      },
    },
    en: {
      translation: {
        dashboard: 'Overview',
        myActions: 'My actions',
        dataQuality: 'Data quality',
        projects: 'Projects',
        capacity: 'Capacity',
        resources: 'Resources',
        insights: 'Insights',
        planning: 'Planning',
        planningTriage: 'Planning triage',
        budgets: 'Budgets',
        billing: 'Billing',
        financialForecast: 'Financial forecast',
        governance: 'Governance',
        reports: 'Reports',
        integrations: 'Integrations',
        settings: 'Settings',
        settingsNavClients: 'Clients and tracking',
        tempoTracking: 'Tempo tracking',
        settingsForecast: 'Forecast and capacity',
        settingsRates: 'Client rates',
        settingsBudgetImports: 'Budget imports',
        accessAdmin: {
          navigation: 'Administration',
          title: 'Access and Tempo teams',
          intro: 'View Tempo teams and manage local permissions in access scopes.',
          users: 'Users',
          roles: 'Roles',
          teams: 'Teams',
          review: 'Access review',
          projects: 'Projects',
          resources: 'Resources',
          members: 'Members',
          newUser: 'New user',
          newRole: 'New role',
          newTeam: 'New team',
          email: 'Novatize email',
          description: 'Description',
          globalRoles: 'Global roles',
          teamRoles: 'Team roles',
          activeAccount: 'Active account',
          active: 'Active',
          disabled: 'Disabled',
          archived: 'Archived',
          archive: 'Archive',
          restore: 'Restore',
          pending: 'Access pending',
          projectScope: 'Team or global scope',
          globalScope: 'Global scope only',
          permissionLevels: {
            read: 'View',
            manage: 'Manage',
            sensitive: 'Sensitive action',
          },
          permissionGroups: {
            users: 'Users',
            roles: 'Roles',
            teams: 'Teams',
            api_docs: 'API documentation',
            clients: 'Clients',
            projects: 'Projects',
            capacity: 'Capacity',
            forecast: 'Forecasting',
            financials: 'Financial rates',
            agent: 'Agent',
            planning: 'Planning',
            budgets: 'Budgets',
            billing: 'Billing',
            governance: 'Governance',
            reports: 'Reports',
            settings: 'Settings',
            integrations: 'Integrations',
          },
        },
        settingsClients: {
          title: 'Settings',
          intro: 'Choose which Tempo clients and projects feed operational views.',
          clients: 'Clients',
          refresh: 'Refresh from Tempo',
          refreshing: 'Queueing…',
          refreshQueued: 'Tempo synchronization queued.',
          excluded: '{{count}} Tempo Account(s) excluded because they have no Customer.',
          excludedHelp: 'Assign a Customer in Tempo to make them eligible.',
          search: 'Search',
          searchPlaceholder: 'Client, project, or Tempo key',
          tracking: 'Tracking',
          all: 'All',
          tracked: 'Tracked',
          untracked: 'Not tracked',
          tempoStatus: 'Tempo status',
          clientProject: 'Client / project',
          key: 'Key',
          status: 'Status',
          activity: 'Activity',
          spaces: 'Spaces',
          projectsTracked: '{{tracked}}/{{total}} projects tracked',
          automatic: 'Automatic',
          manual: 'Manual',
          followed: 'Tracked',
          ignored: 'Ignored',
          returnAutomatic: 'Return to automatic',
          noCategory: 'No category',
          defaultSpace: 'default',
          ambiguousMapping: 'ambiguous mapping',
          notLinked: 'Not linked',
          inheritClient: 'Inherit from client',
          contractSigned: 'Project signed',
          signed: 'Signed',
          notSigned: 'Needs signature',
          configureBillingEpic: 'Configure TCC epic',
          billingEpic: 'TCC epic',
          billingEpicHelp: 'The controlled title is used by default; a Jira override is optional.',
          billingEpicAutomatic: 'Automatic — controlled title by default',
          saveBillingEpic: 'Save TCC epic',
          savingBillingEpic: 'Saving…',
          loadingBillingEpic: 'Loading Jira candidates…',
          billingEpicError: 'Unable to load Jira candidates.',
          noRecentActivity: 'No recent activity',
          expand: 'Expand {{name}}',
          collapse: 'Collapse {{name}}',
        },
        shell: {
          mainNavigation: 'Main navigation',
          settingsNavigation: 'Settings sections',
          integrationsNavigation: 'Integration sections',
          searchLabel: 'Global search',
          searchPlaceholder: 'Search for a project or person',
          searchLoading: 'Searching…',
          searchEmpty: 'No authorized results.',
          accessPending: 'Access pending',
          accessPendingDescription: 'Your account is active, but no role has been assigned yet.',
          loading: 'Loading securely…',
          apiUnavailable: 'The application cannot reach its API.',
          unexpectedError: 'An unexpected error occurred.',
          helpCenter: 'Help center',
          french: 'French',
          english: 'English',
          englishExperimentalTitle: 'English is still experimental; some views remain in French.',
          frenchReferenceTitle: 'Return to the complete reference language.',
        },
        integrationPage: {
          title: 'Integrations',
          intro:
            'Read-only external connectors, nightly reconciliation, and audited synchronization.',
          health: 'Health and synchronizations',
          configuration: 'Configuration',
          reconciliation: 'Reconciliation',
          fullReconciliation: 'Full reconciliation',
          configured: 'Configured',
          disconnected: 'Disconnected',
          notConfigured: 'Not configured',
          test: 'Test',
          sync: 'Synchronize',
          disconnect: 'Disconnect',
          reconnect: 'Reconnect',
          confirmReconnect: 'Reconnect HubSpot and reactivate its synchronizations?',
          confirmDisconnect: 'Disconnect HubSpot? Existing data and mappings will be kept.',
          recentRuns: 'Recent runs',
          lastRun: 'Last run',
          inProgress: 'updating',
          syncFailed: 'Synchronization failed.',
          connectionConfirmed: 'Connection confirmed',
        },
        dataQualityPage: {
          title: 'Data quality',
          intro:
            'Missing contracts, mappings, budgets, and rates prioritized with corrective actions.',
          allStatuses: 'All statuses',
          open: 'Open',
          resolved: 'Resolved',
          ignored: 'Ignored',
          allPriorities: 'All priorities',
          critical: 'Critical',
          high: 'High',
          medium: 'Medium',
          low: 'Low',
          refresh: 'Reanalyze',
          none: 'No issues detected.',
          owner: 'Owner of {{kind}} — {{project}}',
          priority: 'Priority of {{kind}} — {{project}}',
          noOwner: 'No owner',
          resolve: 'Resolve',
          ignore: 'Ignore',
          sourceDetected: 'Source {{source}} · detected on {{date}}',
          anomalies: 'issue',
          anomaliesPlural: 'issues',
        },
        forecastSettingsPage: {
          title: 'Capacity configuration',
          intro:
            'Define organizational values and review primary roles and commitments synchronized from Tempo.',
          save: 'Save default values',
          saving: 'Saving…',
          capacity: 'Capacity and billable target',
          thresholds: 'Alert thresholds',
          weeklyCapacity: 'Weekly capacity (h)',
          weeklyTarget: 'Billable target (h)',
          rounding: 'Allocation rounding (min)',
          sprintAnchor: 'Sprint anchor (Wednesday)',
          sprintLength: 'Sprint cadence (weeks)',
          inactivity: 'No recent activity after (days)',
          tempoTeam: 'Tempo team, capacity, and primary roles',
        },
        login: {
          eyebrow: 'Production management',
          title: 'A reliable view of workload and profitability.',
          description: 'Access is restricted to Google @novatize.com accounts.',
          continue: 'Continue with Google',
          oauthMissing: 'Google OAuth must be configured.',
        },
        dataChain: {
          save: 'Save',
          cancel: 'Cancel',
          close: 'Close',
          create: 'Create',
          add: 'Add',
          edit: 'Edit',
          manage: 'Manage',
          syncAll: 'Synchronize all',
          map: 'Map',
          mapConfirm: 'Map and confirm',
          contractStart: 'Production start',
          contractEnd: 'Production end',
          contract: 'Contract',
          purchaseOrder: 'Purchase order',
          currency: 'Currency',
          name: 'Name',
          category: 'Category',
          amount: 'Amount',
          budgetHours: 'Budgeted hours',
          resource: 'Resource',
          expertise: 'Expertise',
          type: 'Type',
          start: 'Start',
          end: 'End',
          hours: 'Hours',
          title: 'Title',
          dueDate: 'Due date',
          description: 'Description',
          context: 'Context',
          reason: 'Reason',
          date: 'Date',
          unavailableHours: 'Unavailable hours',
          destinationProject: 'Destination project',
          tempoAccount: 'Tempo Account',
          startDateField: 'Start date',
          jiraAbsenceIds: 'Jira issues for Tempo Timesheets absences',
        },
      },
    },
  },
});

export default i18n;

/** Resolve the two supported product locales without allowing browser locale drift. */
function appLocale(language: string | undefined = i18n.language): AppLocale {
  return language?.toLowerCase().startsWith('en') ? 'en' : 'fr';
}

export function formatMoney(
  amountMinor: number,
  currency: string,
  language: string | undefined = i18n.language,
): string {
  const normalizedCurrency = /^[A-Z]{3}$/.test(currency) ? currency : 'CAD';
  return new Intl.NumberFormat(appLocale(language) === 'en' ? 'en-CA' : 'fr-CA', {
    style: 'currency',
    currency: normalizedCurrency,
  }).format(amountMinor / 100);
}

export function formatHours(
  minutes: number,
  maximumFractionDigits = 1,
  language: string | undefined = i18n.language,
): string {
  const locale = appLocale(language);
  const unit = locale === 'en' ? 'h' : 'h';
  return `${new Intl.NumberFormat(locale === 'en' ? 'en-CA' : 'fr-CA', {
    maximumFractionDigits,
  }).format(minutes / 60)} ${unit}`;
}

/**
 * Format a date-only value without interpreting it in the user's local timezone.
 * Instants, on the other hand, are always rendered in the explicit product timezone.
 */
export function formatDate(
  value: string | null | undefined,
  language: string | undefined = i18n.language,
  timeZone = DEFAULT_TIME_ZONE,
): string {
  if (!value) return '—';
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(value);
  const date = dateOnly ? new Date(`${value}T00:00:00.000Z`) : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(appLocale(language) === 'en' ? 'en-CA' : 'fr-CA', {
    dateStyle: 'medium',
    timeZone: dateOnly ? 'UTC' : timeZone,
  }).format(date);
}

export function formatDateTime(
  value: string | null | undefined,
  language: string | undefined = i18n.language,
  timeZone = DEFAULT_TIME_ZONE,
): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(appLocale(language) === 'en' ? 'en-CA' : 'fr-CA', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone,
  }).format(date);
}
